import { GamepadRightIcon } from './GamepadRightIcon';

/**
 * author: GreenTurtwig
 * id D513E54E-6492-4C2A-99E9-3E50C5662B88
 * name gamepad-right
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-right.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerRightIcon = GamepadRightIcon;
export default ControllerRightIcon